import { response_type, response_type_internal } from '../interfaces';

// 把所有 response 裡駝峰式命名的 key 改成用底線隔開的
export function common_process(response: response_type, no_sorting?: 1, no_underlined_key?: 1): response_type {
  let new_key: string;
  return Array.isArray(response)
    ? check_no_sorting(response)
    : response?.items
    ? Object.assign(response, {
        items: check_no_sorting(response.items)
      })
    : rename_key(response);

  function check_no_sorting(items: (response_type_internal | undefined)[]) {
    const renamed_items: (response_type_internal | undefined)[] = items.map((item_each: any | undefined) => rename_key(item_each));
    return no_sorting ? renamed_items : renamed_items.sort((a: any, b: any) => a && a.name?.localeCompare(b?.name));
  }

  function rename_key(response_each: response_type_internal | undefined): response_type_internal | undefined {
    if (no_underlined_key) return response_each;
    response_each &&
      Object.keys(response_each).forEach((old_key: string) => {
        (response_each as any)[old_key] = (() => {
          const value = (response_each as any)[old_key];
          return value && typeof value === 'object' ? rename_key(value) : value;
        })();

        new_key = old_key
          .replace(/\.?([A-Z]+)/g, (_x, y) => '_' + y.toLowerCase())
          .replace(/^_/, '')
          .replace(/-/g, '_');

        if (old_key !== new_key) {
          Object.defineProperty(response_each, new_key, Object.getOwnPropertyDescriptor(response_each, old_key) || {});
          delete (response_each as any)[old_key];
        }
      });
    return response_each;
  }
}
